import React from 'react';
import { motion } from 'framer-motion';

interface ProjectCardProps {
  title: string;
  description: string;
  image: string;
  creator: 'Roscoe' | 'Matthew' | 'Both';
  link?: string;
  tags?: string[];
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  description,
  image,
  creator,
  link,
  tags = [],
}) => {
  const getCreatorStyles = () => {
    if (creator === 'Roscoe') {
      return { backgroundColor: '#4A90E2', color: '#FFFFFF' };
    } else if (creator === 'Matthew') {
      return { backgroundColor: '#F5A623', color: '#FFFFFF' };
    } else {
      return { backgroundColor: '#7ED321', color: '#FFFFFF' };
    }
  };
  
  return (
    <motion.div 
      className="bg-white rounded-lg overflow-hidden shadow-sm"
      whileHover={{ y: -4 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="relative aspect-video overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
        <div 
          className="absolute top-2 right-2 px-3 py-1 rounded-full text-sm font-medium"
          style={getCreatorStyles()}
        >
          {creator}
        </div>
      </div>
      
      <div className="p-4">
        <h3 className="text-lg font-bold mb-2">{title}</h3>
        <p className="text-dark-gray mb-4 line-clamp-2">{description}</p>
        
        {tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {tags.map((tag) => (
              <span 
                key={tag}
                className="px-2 py-1 text-xs font-medium rounded-full"
                style={{ backgroundColor: '#E5E5E5', color: '#333333' }}
              >
                {tag}
              </span>
            ))}
          </div>
        )}
        
        {link && (
          <a 
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-black font-medium hover:text-brand-accent transition-colors"
          >
            View Project
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        )}
      </div>
    </motion.div>
  );
};

export default ProjectCard; 